module.exports = __webpack_public_path__ + "static/media/logo-xpdconnect-blanco.d683bcc1.png";